import { useState } from "react";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogTrigger, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Upload, Download } from "lucide-react";
import { downloadFile, MONTHS } from "@/components/payroll/dl";

export function MonthlyImportDialog({ clientId, year, month, onDone }) {
  const [open, setOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [mode, setMode] = useState("replace");
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const upload = async () => {
    if (!file) { toast.error("Pilih file Excel"); return; }
    if (mode === "replace" && !window.confirm(`Semua transaksi ${MONTHS[month - 1]} ${year} akan dihapus dan diganti isi file. Lanjutkan?`)) return;
    const fd = new FormData();
    fd.append("client_id", clientId); fd.append("year", year); fd.append("month", month); fd.append("mode", mode); fd.append("file", file);
    setBusy(true);
    try {
      const { data } = await api.post("/payroll/import", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setRes(data); toast.success(`${data.imported} baris diimpor`); onDone();
    } catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={(v) => { setOpen(v); if (!v) { setRes(null); setFile(null); } }}>
      <DialogTrigger asChild><Button variant="outline" size="sm" data-testid="monthly-import-btn"><Upload className="h-4 w-4 mr-1" />Impor Excel</Button></DialogTrigger>
      <DialogContent>
        <DialogHeader><DialogTitle>Impor Transaksi PPh 21 — {MONTHS[month - 1]} {year}</DialogTitle>
          <DialogDescription className="text-xs">Kolom mengikuti kebutuhan Coretax. Karyawan dengan ID / Nama + NIK sama otomatis dipakai ulang, tidak dibuat ganda.</DialogDescription></DialogHeader>
        <div className="space-y-3">
          <Button variant="outline" size="sm" onClick={() => downloadFile(`/payroll/import-template?client_id=${clientId}&year=${year}&month=${month}`, `template_pph21_${year}_${month}.xlsx`)} data-testid="monthly-template-btn"><Download className="h-4 w-4 mr-1" />Unduh Template (terisi data bulan ini)</Button>
          <div className="space-y-1.5"><Label className="text-xs">Mode</Label>
            <Select value={mode} onValueChange={setMode}>
              <SelectTrigger data-testid="monthly-import-mode"><SelectValue /></SelectTrigger>
              <SelectContent><SelectItem value="replace">Hapus & ganti seluruh data bulan ini</SelectItem><SelectItem value="merge">Perbarui per karyawan (yang lain tetap)</SelectItem></SelectContent>
            </Select>
          </div>
          <Input type="file" accept=".xlsx,.xls,.csv" onChange={(e) => setFile(e.target.files?.[0] || null)} data-testid="monthly-import-file" />
          {res && (
            <div className="rounded-md bg-secondary/40 p-2 text-xs space-y-1" data-testid="monthly-import-result">
              <p>{res.imported} baris diimpor · {res.created_employees} karyawan baru · {res.updated_employees} karyawan diperbarui</p>
              {res.errors?.map((er, i) => <p key={i} className="text-rose-600">{er}</p>)}
            </div>
          )}
        </div>
        <DialogFooter><Button onClick={upload} disabled={busy} data-testid="monthly-import-submit">{busy ? "Mengimpor..." : "Impor"}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
